import JobWorkerInterviewWorkerDeclinedReason from "@/models/JobWorkerInterviews/JobWorkerInterviewWorkerDeclinedReason";

export default (reason: JobWorkerInterviewWorkerDeclinedReason) => {
    let returnVal = "Undefined"
    switch (reason) {
        case JobWorkerInterviewWorkerDeclinedReason.NoLongerInterested:
            returnVal = "No longer interested in this position";
            break;
        case JobWorkerInterviewWorkerDeclinedReason.Unavailable:
            returnVal = "Unavailable at this time";
            break;
        default:
            returnVal = "Undefined";
            break;
    }
    return returnVal;
}